enum Duration {
  eighthNote = "8n",
  quarterNote = "4n",
  halfNote = "2n",
  dottedHalfNote = "2n.",
  fullNote = "1n",
}

export default Duration;
